import { useEffect } from 'react';
import { isAmazonHost } from '../utils';
import { useConsentManager, usePrivacyCookie, useRWA } from './';

export const useThirdPartyAnalytics = () => {
  const isTrackingAccepted = useConsentManager();
  const isRWAAllowed = usePrivacyCookie('analytics_heap');
  const { load: loadRWA } = useRWA();

  useEffect(() => {
    /**
     * Analytics will be enabled when one of the following use cases occurs (only on r.com):
     * - User has allowed analytics tracking before (we can check this through the privacy cookie)
     * - User clicks the "accept" button in the consent manager banner
     */
    if (!isAmazonHost()) {
      if (isRWAAllowed || isTrackingAccepted) {
        loadRWA();
      }
    }
  }, [isRWAAllowed, isTrackingAccepted, loadRWA]);
};
